export default function ServiceRetrofit({ size = 96 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 96 96" fill="none" aria-hidden="true">
      <rect x="14" y="36" width="36" height="36" stroke="currentColor" strokeWidth="1.25" />
      <rect x="50" y="20" width="32" height="32" stroke="currentColor" strokeWidth="1.25" />
      <path d="M14 54 H50 M32 36 V72 M50 36 V20" stroke="currentColor" strokeWidth="1.25" />
      <path
        d="M62 60 a8 8 0 1 0 8 8"
        stroke="#54B53C"
        strokeWidth="1.25"
        strokeLinecap="round"
      />
      <path d="M70 60 L74 60 L74 56" stroke="#54B53C" strokeWidth="1.25" />
    </svg>
  );
}
